// src/pages/MobilePanoramaPage.tsx
import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Viewer } from '@photo-sphere-viewer/core';
import { AutorotatePlugin } from '@photo-sphere-viewer/autorotate-plugin';
import '@photo-sphere-viewer/core/index.css';

const panoramaImages = [
  { title: 'Obývací pokoj', path: '/images/obyvak.webp' },
  { title: 'Kuchyň', path: '/images/kuchyn.webp' },
  { title: 'Ložnice 1', path: '/images/loznice1.webp' },
  { title: 'Ložnice 2', path: '/images/loznice2.webp' },
  { title: 'Ložnice 2 - 1', path: '/images/loznice_1_1.webp' },
  { title: 'Chodba', path: '/images/chodba.webp' },
  { title: 'Koupelna', path: '/images/koupelna.webp' },
];

interface AutorotatePluginInstance {
  start: () => void;
}

const MobilePanoramaPage: React.FC = () => {
  const viewerRef = useRef<HTMLDivElement>(null);
  const [params] = useSearchParams();
  const image = decodeURIComponent(params.get('image') || '');

  const imageExists = panoramaImages.some((img) => img.path === image);

  useEffect(() => {
    if (!viewerRef.current || !image || !imageExists) return;

    const viewer = new Viewer({
      container: viewerRef.current,
      panorama: image,
      plugins: [[AutorotatePlugin, { autorotateSpeed: '1rpm' }]],
      navbar: ['zoom', 'fullscreen', 'autorotate'],
    });

    const autorotate = viewer.getPlugin(AutorotatePlugin) as unknown as AutorotatePluginInstance;
    if (autorotate && typeof autorotate.start === 'function') {
      setTimeout(() => autorotate.start(), 500);
    }

    return () => {
      viewer.destroy();
    };
  }, [image, imageExists]);

  if (!imageExists) {
    return (
      <div className="fixed top-0 left-0 w-screen h-[100dvh] bg-black text-white flex items-center justify-center z-50">
        Neplatný obrázek
      </div>
    );
  }

  return (
    <div
      ref={viewerRef}
      className="fixed top-0 left-0 w-screen h-[100dvh] bg-black z-50"
    />
  );
};

export default MobilePanoramaPage;
